import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/valeur/valeur2.jpeg")